// common business logic related util methods
import axios from "axios";
import { baseUri } from "../config/config";
import { getAccessToken, setAccessToken } from "./tokenManager";

axios.defaults.headers.post["Content-Type"] = "application/json";

const _url = "https://cors-anywhere.herokuapp.com/";

const list_for_credentials_true = ["api/app_api/login", "api/app_api/logout"];

// ---- token refresh lock ----
let refreshPromise = null; // shared promise all concurrent 401s await
let lastRefreshTime = 0; // ms timestamp of last SUCCESSFUL refresh
const REFRESH_WINDOW_MS = 30000; // 30s

const axios_call = async (reqObj) => {
  try {
    let results = await axios(reqObj);
    console.info("<===Api-Success-Result===>", results);
    return results.data;
  } catch (error) {
    console.info("<===Api-Error===>", error?.response?.data);

    if (error.response.status === 410) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      code: error?.response?.status || 400,
      message:
        error?.response?.data?.message || "Server did not sent any response.",
    };
  }
};

const callRefreshTokenApi = async () => {
  const refreshRequest = {
    method: "POST",
    url: baseUri + `api/app_api/refresh_token`,
    headers: {
      "x-sh-auth": "",
    },
    withCredentials: true,
  };
  console.info("<=== Refresh Token API Call ===>");

  const refreshResponse = await axios_call(refreshRequest);

  if (refreshResponse.code === 200) {
    console.info("<===Refresh API token Response===>", refreshResponse);
    setAccessToken(refreshResponse?.token);
    lastRefreshTime = Date.now();
    return refreshResponse;
  }

  // propagate failure so every waiting caller sees it
  throw refreshResponse;
};

// Ensures only ONE refresh call happens for any burst of concurrent 401s,
// and skips calling it again if a refresh already succeeded within the last 30s.
const getRefreshedToken = () => {
  if (!refreshPromise) {
    if (Date.now() - lastRefreshTime < REFRESH_WINDOW_MS) {
      // a refresh just happened moments ago (via another concurrent call) —
      // reuse the token that's already set instead of hitting the API again
      return Promise.resolve({ code: 200, token: getAccessToken() });
    }

    refreshPromise = callRefreshTokenApi().finally(() => {
      refreshPromise = null; // release the lock whether it succeeded or failed
    });
  }
  return refreshPromise;
};

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: baseUri + path,
    headers: {
      ...headers,
      "x-sh-auth": getAccessToken() || "",
    },
    withCredentials: list_for_credentials_true.includes(path) ? true : false,
  };

  reqObj.params = queryParams;

  if (method === "POST" || method === "PUT" || method === "DELETE") {
    reqObj.data = postData;
  }

  console.info("<===REQUEST-OBJECT===>", reqObj);

  let results = await axios_call(reqObj);

  if (results.code === 401) {
    try {
      const refreshResponse = await getRefreshedToken();
      results = await axios_call({
        ...reqObj,
        headers: {
          ...headers,
          "x-sh-auth": refreshResponse?.token,
        },
      });
    } catch (refreshError) {
      results = refreshError;
    }
  }

  return results;
}
